module.exports = __webpack_public_path__ + "static/media/prev-question.4b322064.svg";